import type { ICellRendererParams } from '@mint-lib/ag-grid/community';

import { isFolderNode } from '../../../../helpers/knowledge-base/fileSystemNode.js';
import type { FileSystemNode } from '../../../../types/fileSystem.js';
import type { RagTableType } from '../../../../types/rag.js';

export const FOLDER_DRAFT_ROW_ID = 'folder-draft';

export const FOLDER_DRAFT_ROWS = [
  { kind: 'draft' },
] as unknown as FileSystemNode[];

type GridNode = { data?: FileSystemNode } | null;

export const isDraftRow = (params: { node?: { rowPinned?: unknown } | null }) =>
  Boolean(params.node?.rowPinned);

export const asFileCellParams = (params: ICellRendererParams<FileSystemNode>) =>
  params as unknown as ICellRendererParams<RagTableType>;

const toSortableString = (value: unknown): string => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean')
    return value.toString();
  if (value instanceof Date) return value.toISOString();

  return JSON.stringify(value) ?? '';
};

const compareValues = (valueA: unknown, valueB: unknown) => {
  if (valueA === valueB) return 0;

  if (valueA == null) return -1;
  if (valueB == null) return 1;

  return toSortableString(valueA).localeCompare(toSortableString(valueB));
};

const folderRank = (node: GridNode) => (isFolderNode(node?.data) ? 0 : 1);

export const foldersFirstComparator = (
  valueA: unknown,
  valueB: unknown,
  nodeA: GridNode,
  nodeB: GridNode,
  descending: boolean,
) => {
  const rankDiff = folderRank(nodeA) - folderRank(nodeB);

  if (rankDiff !== 0) return descending ? -rankDiff : rankDiff;

  return compareValues(valueA, valueB);
};
